import { render, staticRenderFns } from "./agentAccesstop.vue?vue&type=template&id=67aea3ec&scoped=true&"
import script from "./agentAccesstop.vue?vue&type=script&lang=js&"
export * from "./agentAccesstop.vue?vue&type=script&lang=js&"
import style0 from "./agentAccesstop.vue?vue&type=style&index=0&id=67aea3ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aea3ec",
  null
  
)

export default component.exports